export const defaultRobotProfileWidgets = [
	{
		enabled: true,
		id: "alerts",
		index: 0
	},
	{
		enabled: true,
		id: "activities",
		index: 1
	},
	{
		enabled: true,
		id: "files",
		index: 2
	},
	{
		enabled: true,
		id: "cameras",
		index: 3
	},
	{
		enabled: true,
		id: "robotCameras",
		index: 4
	},
	{
		enabled: true,
		id: "missionControl",
		index: 5
	}
];
